// Pustený odkaz, obrázok alebo súbor mimo miesta, ktoré ho spracuje, by prehliadač
// otvoril namiesto adminky — a rozrobený box by bol preč. Povolené ostáva len
// vkladanie textu do polí; triedenie a vlastné drop zóny volajú preventDefault
// skôr (bublajú sem až potom), takže ich to neovplyvní.
const isEditable = (target) =>
	target instanceof Element &&
	!!target.closest('input, textarea, [contenteditable=""], [contenteditable="true"]')

export default defineNuxtPlugin(() => {
	window.addEventListener('dragover', (event) => {
		if (event.defaultPrevented || isEditable(event.target)) return

		event.preventDefault()
		if (event.dataTransfer) event.dataTransfer.dropEffect = 'none'
	})

	window.addEventListener('drop', (event) => {
		if (isEditable(event.target)) return

		event.preventDefault()
	})
})
